// DÍA 1 · MOTOR DEMO MÍNIMO (frontend-only). NO clona el backend ni construye un segundo motor:
// sólo deriva los campos que la UI CURRENT necesita (siguiente_accion / acciones_permitidas /
// resultados_permitidos / secuencia_combinada) desde el estado LOCAL del caso, y aplica la
// consecuencia visible de cada acción del operador. Semántica alineada con protocolo_dia1.py:
// la consola guía, la persona decide; las lecturas son hechos, no diagnóstico.

const RES = {
  persona_bien: "La persona está bien",
  pide_avisar: "Pide avisar a un familiar/contacto",
  pide_emergencia: "Pide servicios de emergencia",
  comunicacion_incompleta: "Comunicación incompleta",
  no_responde: "No responde",
  confirmado_contacto: "Un contacto autorizado confirmó su estado",
  actividad_normal: "Actividad normal (sin caso)",
  falsa_alarma: "Falsa alarma",
  lectura_fuera_rango: "Lectura fuera del umbral configurado",
  regreso_rango: "La lectura regresó al rango (el caso NO se autocierra)",
};
// INSTITUCIONAL — mismo contrato de códigos, lenguaje del centro: "la tecnología detecta, la
// consola organiza, el equipo del centro atiende". Ni diagnóstico ni interpretación clínica.
const RES_INST = {
  persona_bien: "Atendido por el personal · sin novedad",
  actividad_normal: "Actividad normal · acompañado por el personal",
  pide_avisar: "Requiere apoyo · escalar internamente",
  pide_emergencia: "Requiere traslado o servicios de emergencia",
  comunicacion_incompleta: "Verificación incompleta",
  no_responde: "No localizado en la ubicación",
  confirmado_contacto: "Confirmado por el responsable de turno",
  falsa_alarma: "Sin hallazgo al verificar",
  lectura_fuera_rango: "Lectura fuera del umbral configurado",
  regreso_rango: "La lectura regresó al rango (el caso NO se autocierra)",
};
export const esInstitucional = (d) => (d || {})._modalidad === "institucional";
const lbl = (c, inst) => (inst ? RES_INST[c] || RES[c] : RES[c]);
const chips = (codigos, inst) => codigos.map((c) => ({ codigo: c, etiqueta: lbl(c, inst) }));
const DESENLACE_TXT = {
  VERIFICADO_DIRECTO: "Verificado directamente",
  VERIFICADO_CONTACTO_AUTORIZADO: "Verificado por contacto autorizado",
  NO_VERIFICABLE: "No verificable",
};
const DESENLACE_TXT_INST = {
  VERIFICADO_DIRECTO: "Atención verificada por el personal del centro",
  VERIFICADO_CONTACTO_AUTORIZADO: "Confirmado por un contacto autorizado (aviso secundario)",
  NO_VERIFICABLE: "No verificable",
};

// 9 familias canónicas (subconjunto usado por los fixtures demo).
const FAMILIAS = {
  caida: { primera: "INICIAR AUDIO / HABLAR CON LA PERSONA",
    resultados: ["persona_bien", "pide_avisar", "pide_emergencia", "comunicacion_incompleta", "no_responde", "confirmado_contacto", "falsa_alarma"] },
  boton_panico: { primera: "INICIAR AUDIO / HABLAR CON LA PERSONA",
    resultados: ["persona_bien", "pide_avisar", "pide_emergencia", "comunicacion_incompleta", "no_responde", "confirmado_contacto", "falsa_alarma"] },
  salida_bano_sin_retorno: { primera: "VERIFICAR ESTADO DE LA PERSONA",
    resultados: ["persona_bien", "confirmado_contacto", "pide_emergencia", "no_responde", "falsa_alarma"] },
  fuera_de_cama_nocturno_sin_retorno: { primera: "VERIFICAR ESTADO DE LA PERSONA",
    resultados: ["persona_bien", "confirmado_contacto", "no_responde", "falsa_alarma"] },
  fuera_de_zona_permitida: { primera: "VERIFICAR ESTADO DE LA PERSONA",
    resultados: ["persona_bien", "confirmado_contacto", "actividad_normal", "falsa_alarma"] },
  excepcion_frecuencia_cardiaca: { primera: "VERIFICAR ESTADO DE LA PERSONA",
    resultados: ["lectura_fuera_rango", "persona_bien", "confirmado_contacto", "regreso_rango", "no_responde", "falsa_alarma"] },
  excepcion_frecuencia_respiratoria: { primera: "VERIFICAR ESTADO DE LA PERSONA",
    resultados: ["lectura_fuera_rango", "persona_bien", "confirmado_contacto", "regreso_rango", "no_responde", "falsa_alarma"] },
};
const FAM_DEFAULT = { primera: "VERIFICAR ESTADO DE LA PERSONA",
  resultados: ["persona_bien", "confirmado_contacto", "no_responde", "falsa_alarma"] };
const fam = (tipo) => FAMILIAS[tipo] || FAM_DEFAULT;

// Secuencia institucional: ALERTA → TOMAR → MOVILIZAR AL PERSONAL → VERIFICAR EN LA UBICACIÓN →
// REGISTRAR RESULTADO → ESCALAR INTERNAMENTE SI CORRESPONDE → CERRAR. La primera línea de respuesta
// NUNCA es llamar a un familiar/contacto externo ni hablar con el residente en lugar de verificarlo.
const VERIF_INST = ["persona_bien", "actividad_normal", "pide_avisar", "no_responde", "falsa_alarma"];
const FAMILIAS_INST = {
  caida: { primera: "ACUDIR A LA UBICACIÓN Y CONFIRMAR ATENCIÓN PRESENCIAL",
    resultados: ["persona_bien", "pide_avisar", "pide_emergencia", "no_responde", "falsa_alarma"] },
  boton_panico: { primera: "ACUDIR A LA UBICACIÓN Y CONFIRMAR ATENCIÓN PRESENCIAL",
    resultados: ["persona_bien", "pide_avisar", "pide_emergencia", "no_responde", "falsa_alarma"] },
  fuera_de_cama_nocturno_sin_retorno: { primera: "SOLICITAR RONDA EN LA HABITACIÓN Y VERIFICAR AL RESIDENTE", resultados: VERIF_INST },
  salida_bano_sin_retorno: { primera: "VERIFICAR HABITACIÓN Y BAÑO CON EL PERSONAL DEL CENTRO", resultados: VERIF_INST },
  permanencia_prolongada_zona: { primera: "VERIFICAR LA ZONA INDICADA CON EL PERSONAL DEL CENTRO", resultados: VERIF_INST },
  fuera_de_zona_permitida: { primera: "VERIFICAR LA ZONA INDICADA CON EL PERSONAL DEL CENTRO", resultados: VERIF_INST },
  excepcion_frecuencia_cardiaca: { primera: "AVISAR A ENFERMERÍA / RESPONSABLE DE TURNO Y COMPROBAR AL RESIDENTE EN SU HABITACIÓN",
    resultados: ["lectura_fuera_rango", "persona_bien", "pide_avisar", "pide_emergencia", "regreso_rango", "no_responde", "falsa_alarma"] },
  excepcion_frecuencia_respiratoria: { primera: "AVISAR A ENFERMERÍA / RESPONSABLE DE TURNO Y COMPROBAR AL RESIDENTE EN SU HABITACIÓN",
    resultados: ["lectura_fuera_rango", "persona_bien", "pide_avisar", "pide_emergencia", "regreso_rango", "no_responde", "falsa_alarma"] },
};
const FAM_INST_DEFAULT = { primera: "VERIFICAR EN LA UBICACIÓN CON EL PERSONAL DEL CENTRO", resultados: VERIF_INST };
const famInst = (tipo) => FAMILIAS_INST[tipo] || FAM_INST_DEFAULT;

// Resultados que NO son terminales: la ruta continúa (nunca se cierra por sí solos).
const CONTINUAR = new Set(["no_responde", "comunicacion_incompleta", "lectura_fuera_rango", "regreso_rango"]);
const CONTACTO_RESULTADOS = ["confirmado_contacto", "no_responde", "comunicacion_incompleta"];
const GESTION_TXT = { contactado: "Contactado", no_contesto: "No contestó", buzon: "Buzón",
  numero_equivocado: "Número equivocado", acudira_en_sitio: "Acudirá en sitio" };
// Espejo del contrato del backend (casos_dia1.CANAL_POR_KIND / RESULTADOS_EVIDENCIA_DISPOSITIVO).
const CANAL_KIND = { audio_persona: "audio", llamada_persona: "telefono_persona",
  llamada_contacto: "telefono_contacto", aviso_contacto: "telefono_contacto",
  confirmacion_tercero: "telefono_contacto", accion_final: "presencial",
  verificacion_persona: "presencial", evidencia_dispositivo: null };
const EVIDENCIA_RES = new Set(["lectura_fuera_rango", "regreso_rango"]);

const ultimo = (arr, fn) => (arr || []).filter(fn).slice(-1)[0] || null;

// ------------------------------------------------------------------ derivación (read-model demo)
export function derivarDia1(d) {
  const journal = d.journal || [];
  const estado = d.estado;
  const inst = esInstitucional(d);
  if (estado === "cerrada") {
    return { siguiente_accion: { kind: "cerrado", etiqueta: "Caso cerrado. Sin acción pendiente." },
      acciones_permitidas: [], resultados_permitidos: [], secuencia_combinada: secuencia(d) };
  }
  if (estado === "recibida") {
    const etq = d.es_tecnica ? "Toma la incidencia para iniciar el diagnóstico técnico."
      : inst ? "Toma la alerta para movilizar al personal del centro."
        : "Toma la alarma para iniciar el protocolo de atención.";
    return { siguiente_accion: { kind: "tomar", etiqueta: etq },
      acciones_permitidas: ["tomar"], resultados_permitidos: [], secuencia_combinada: secuencia(d) };
  }
  if (d.es_tecnica) {
    return { siguiente_accion: { kind: "tecnico", etiqueta: inst
      ? "Avisar a supervisión / soporte técnico: confirmar luz e internet en el sitio y dar seguimiento hasta el restablecimiento del enlace."
      : "Confirmar luz e internet en el sitio y dar seguimiento hasta el restablecimiento del enlace." },
      acciones_permitidas: ["nota_gestion", "cerrar"], resultados_permitidos: [], secuencia_combinada: secuencia(d) };
  }

  const emer = d.emergencia;
  if (emer && !emer.seguimiento_cumplido_en && !emer.seguimiento_no_obtenible) {
    return { siguiente_accion: { kind: "seguimiento_emergencia", etiqueta: "Confirma el seguimiento con el servicio de emergencia." },
      acciones_permitidas: ["nota_gestion", "cerrar"], resultados_permitidos: [], secuencia_combinada: secuencia(d) };
  }
  const cerrarYa = { siguiente_accion: { kind: "cerrar", etiqueta: "Cierra el caso con la nota factual de lo ocurrido." },
    acciones_permitidas: ["nota_gestion", "cerrar"], resultados_permitidos: [], secuencia_combinada: secuencia(d) };

  if ((d.verificacion_desenlace || {}).codigo) return cerrarYa;
  if (journal.some((x) => x.kind === "accion_final")) return cerrarYa;
  if (journal.some((x) => x.resultado_codigo === "falsa_alarma")) return cerrarYa;
  if (emer) return cerrarYa;

  const resPersona = ultimo(journal, (x) => ["audio_persona", "llamada_persona", "verificacion_persona"].includes(x.kind) && x.resultado_codigo);
  const resContacto = ultimo(journal, (x) => x.kind === "llamada_contacto" && x.resultado_codigo);
  // FLOW-014: un contacto YA gestionado (resultado registrado) no se vuelve a ordenar. Se busca el
  // primer contacto del plan sin hecho registrado; si no queda ninguno, la ruta avanza al plan.
  const gestionados = new Set((d.gestiones_contacto || []).map((g) => g.contacto_id));
  const contactos = d.contactos_resueltos || [];
  const cPend = contactos.find((c) => {
    const cid = c.contacto_id || c.contacto?.id;
    return !gestionados.has(cid) && !ultimo(journal, (x) => x.kind === "llamada_contacto" && x.objetivo === cid && x.resultado_codigo);
  }) || null;

  if (resPersona && (CONTINUAR.has(resPersona.resultado_codigo) || (inst && resPersona.resultado_codigo === "pide_avisar"))) {
    // INSTITUCIONAL: el escalamiento estándar es INTERNO (responsable de turno / enfermería /
    // supervisión). Nunca se ordena llamar a un contacto externo como primera línea.
    if (inst) {
      return { siguiente_accion: { kind: "accion_final", etiqueta: "ESCALAR AL RESPONSABLE DE TURNO / ENFERMERÍA Y REGISTRAR LA GESTIÓN DEL CENTRO" },
        acciones_permitidas: ["nota_gestion", "accion_final"], resultados_permitidos: [], secuencia_combinada: secuencia(d) };
    }
    if (!resContacto && cPend) {
      const cid = cPend.contacto_id || cPend.contacto?.id;
      return { siguiente_accion: { kind: "llamada_contacto", etiqueta: `Llamar a ${cPend.contacto?.nombre_completo} (${cPend.relacion_familiar || "contacto"}).`, telefono: cPend.contacto?.telefono, contacto_id: cid },
        acciones_permitidas: ["nota_gestion", "registrar_resultado"], resultados_permitidos: chips(CONTACTO_RESULTADOS), secuencia_combinada: secuencia(d) };
    }
    return { siguiente_accion: { kind: "accion_final", etiqueta: "Registra la gestión final realizada para cerrar el caso documentado." },
      acciones_permitidas: ["nota_gestion", "accion_final"], resultados_permitidos: [], secuencia_combinada: secuencia(d) };
  }
  if (resPersona) return cerrarYa;

  // INSTITUCIONAL: la verificación PRESENCIAL del personal del centro es el camino estándar. El
  // audio con la habitación es herramienta secundaria y no sustituye esa verificación.
  if (inst) {
    const fi = famInst(d.tipo);
    return { siguiente_accion: { kind: "resultado", etiqueta: fi.primera, hecho_kind: "verificacion_persona" },
      acciones_permitidas: ["nota_gestion", "registrar_resultado"], resultados_permitidos: chips(fi.resultados, true), secuencia_combinada: secuencia(d) };
  }

  // FUNC-002: la primera acción sólo ordena AUDIO si el audio está realmente disponible en esta
  // superficie. Si no, se pide verificar el estado por la vía ejecutable del plan.
  const audioCap = !!(d.recursos_disponibles || {}).audio;
  const f = fam(d.tipo);
  const etiqueta = audioCap ? f.primera : (f.primera.includes("AUDIO") ? "VERIFICAR ESTADO DE LA PERSONA" : f.primera);
  return { siguiente_accion: { kind: "resultado", etiqueta, hecho_kind: audioCap ? "audio_persona" : "verificacion_persona" },
    acciones_permitidas: ["nota_gestion", "registrar_resultado"], resultados_permitidos: chips(f.resultados), secuencia_combinada: secuencia(d) };
}

// Secuencia cronológica visible (mismo read-model que consume CaseDetailV3).
function secuencia(d) {
  const inst = esInstitucional(d);
  const items = [];
  const add = (tipo, hora, actor, detalle, extra) => { if (hora) items.push({ tipo, hora, actor: actor || null, detalle: detalle || null, ...(extra || {}) }); };
  add("recibido", d.hora_recepcion_servidor, "sistema");
  for (const t of d.transiciones || []) {
    if (t.estado === "tomada") add("tomado", t.hora, t.usuario);
    else if (t.estado === "cerrada") add("cierre", t.hora, t.usuario, t.clasificacion);
    else if (t.estado === "recibida" && t.desde) add("liberado", t.hora, t.usuario, t.motivo_codigo);
  }
  for (const p of (d.action_plan_congelado || {}).pasos || []) {
    if (p.ejecutado) add("paso_ejecutado", p.ejecutado_en, p.ejecutado_por, p.texto);
  }
  // AUD-002/AUD-003: cada hecho conserva su clase/canal para que la UI describa lo que REALMENTE
  // ocurrió (evidencia del dispositivo vs. gestión humana por audio/teléfono).
  for (const x of d.journal || []) {
    add(`journal_${x.kind}`, x.created_at, x.actor, lbl(x.resultado_codigo, inst) || x.resultado_codigo || x.resultado_texto_factual,
      { clase: x.clase || (EVIDENCIA_RES.has(x.resultado_codigo) ? "evidencia" : "gestion"),
        canal: x.canal !== undefined ? x.canal : CANAL_KIND[x.kind] || null,
        actor_tipo: x.actor_tipo || "humano" });
  }
  // DATA-006: resultado + motivo + nota del MISMO hecho, consultables desde la secuencia.
  for (const g of d.gestiones_contacto || []) {
    add("gestion_contacto", g.registrado_en, g.registrado_por, g.resultado,
      { clase: "gestion", canal: "telefono_contacto", actor_tipo: "humano",
        datos: { contacto: g.contacto_snapshot?.nombre, relacion: g.contacto_snapshot?.relacion,
                 resultado: g.resultado, motivo: g.motivo, nota: g.nota } });
  }
  const vd = d.verificacion_desenlace;
  if (vd) add("verificacion_desenlace", vd.registrado_en, vd.actor, (inst ? DESENLACE_TXT_INST : DESENLACE_TXT)[vd.codigo] || vd.codigo);
  const e = d.emergencia;
  if (e) {
    add("solicitud_emergencia", e.inicio_en, e.actor, e.motivo);
    add("emergencia_handoff", e.handoff_completado_en, e.actor, e.folio);
    add("seguimiento_emergencia", e.seguimiento_cumplido_en, e.actor);
    if (e.seguimiento_no_obtenible) add("seguimiento_emergencia", e.seguimiento_no_obtenible.en, e.actor, `no obtenible · ${e.seguimiento_no_obtenible.motivo}`);
  }
  for (const n of d.notas_gestion || []) add("journal_nota", n.en, n.por, n.texto);
  return items.sort((a, b) => (a.hora || "").localeCompare(b.hora || ""));
}

export function refrescarDia1(d) {
  if (!d) return d;
  Object.assign(d, derivarDia1(d));
  return d;
}

// ------------------------------------------------------------------ aplicación de acciones (local)
const push = (d, campo, item) => { if (!Array.isArray(d[campo])) d[campo] = []; d[campo].push(item); };
const METODO_CANAL = { audio: "audio", telefono_persona: "telefono_persona", presencial: "personal_en_sitio" };

export function aplicarAccion(d, payload, actor, now) {
  if (!d) return;
  // AUD-002/AUD-003: el canal se DERIVA del hecho (igual que en backend) y una lectura del
  // dispositivo se registra como EVIDENCIA, sin canal humano ni atribución humana.
  const evidencia = EVIDENCIA_RES.has(payload.resultado_codigo);
  const kind = evidencia ? "evidencia_dispositivo" : payload.kind;
  push(d, "journal", { kind, clase: evidencia ? "evidencia" : "gestion",
    canal: evidencia ? null : (CANAL_KIND[payload.kind] || null),
    actor_tipo: evidencia ? "dispositivo" : "humano",
    objetivo: payload.objetivo || null,
    resultado_codigo: payload.resultado_codigo || null, resultado_texto_factual: payload.resultado_texto || null,
    actor: evidencia ? "Dispositivo del sitio" : actor.nombre,
    origen: evidencia ? { tipo: "dispositivo", documentado_por: actor.nombre } : undefined,
    created_at: now });
  const code = payload.resultado_codigo;
  if (code === "persona_bien" || code === "actividad_normal") {
    d.verificacion_desenlace = { codigo: "VERIFICADO_DIRECTO", metodo: METODO_CANAL[CANAL_KIND[payload.kind]] || "otro", actor: actor.nombre, registrado_en: now };
  } else if (code === "confirmado_contacto") {
    d.verificacion_desenlace = { codigo: "VERIFICADO_CONTACTO_AUTORIZADO", contacto_id: payload.objetivo || null, actor: actor.nombre, registrado_en: now };
  } else if (code === "pide_emergencia") {
    d.emergencia = { inicio_en: now, actor: actor.nombre, motivo: "pide_emergencia", handoff_completado_en: now, folio: null };
  } else if (code === "pide_avisar") {
    // La ruta continúa hacia el contacto: se documenta el pedido, no se cierra.
    d._pide_avisar_en = now;
  }
}

export function aplicarDesenlace(d, payload, actor, now) {
  if (!d) return;
  d.verificacion_desenlace = { codigo: payload.codigo, metodo: payload.metodo || null,
    contacto_id: payload.contacto_id || null, actor: actor.nombre, registrado_en: now };
}

export function aplicarGestion(d, contactoId, payload, actor, now) {
  if (!d) return;
  const rel = (d.contactos_resueltos || []).find((c) => (c.contacto_id || c.contacto?.id) === contactoId);
  push(d, "gestiones_contacto", { contacto_id: contactoId, resultado: payload.resultado,
    motivo: payload.motivo || null, nota: payload.nota || null,
    contacto_snapshot: { nombre: rel?.contacto?.nombre_completo || "Contacto", relacion: rel?.relacion_familiar || "" },
    registrado_por: actor.nombre, registrado_en: now });
}

export function aplicarSeguimiento(d, payload, actor, now) {
  if (!d || !d.emergencia) return;
  if (payload.resultado === "cumplido") d.emergencia.seguimiento_cumplido_en = now;
  else d.emergencia.seguimiento_no_obtenible = { motivo: payload.motivo, en: now };
}
